// ✅ SEAMONE Größenrechner – Neue Version
// - Kinder entfernt (nur Damen / Herren)
// - Größenwahl: Oberteil/Kleid nach Brustumfang, Hose/Rock nach Hüftumfang
// - Weitenanpassung bis 2 Größen (sanfter Übergang)
// - Oberbrustumfang OPTIONAL -> FBA/SBA nur bei Oberteilen/Kleidern
// - Hose: Hinweis zur Schrittkurve
// - Tabellen: Universal-Rückfallebene; einzelne Produkte können eine
//   eigene Tabelle über window.SEAMONE_PRODUCT_TABLE einspeisen (Metafeld, Schritt 3)
// Überarbeitung 20.10.2026 (Simo):
// - FBA: Grundgröße und Weitenregel nach Oberbrust + 4 cm (volle Brust zählt nicht mehr als eigene Größe);
//   FBA über 5 cm -> Maßanfertigung empfehlen
// - Hose: Größe nur nach Hüfte; Taille über dem Hüftumfang der Größe -> Hinweis Bauchanpassung
// - Körpergröße wird geprüft (130–210 cm)
// - Optional: Armlänge (Ärmel extra), Oberarm-, Oberschenkel-, Wadenumfang (Warnung „kann zu eng werden“)

console.log("✅ SEAMONE Größenrechner – neue Version geladen");

// ===== STAMMTABELLEN (Körpermaße in cm) =====
const WOMEN_NEW = [ // EU 30–60 (neue, konstruktions-richtige Gradierung)
  { eu: 30, bust: 76,  waist: 60,  hip: 85 },
  { eu: 32, bust: 79,  waist: 63,  hip: 88 },
  { eu: 34, bust: 82,  waist: 66,  hip: 91 },
  { eu: 36, bust: 85,  waist: 69,  hip: 94 },
  { eu: 38, bust: 88,  waist: 72,  hip: 97 },
  { eu: 40, bust: 92,  waist: 76,  hip: 101 },
  { eu: 42, bust: 96,  waist: 80,  hip: 105 },
  { eu: 44, bust: 100, waist: 84,  hip: 109 },
  { eu: 46, bust: 106, waist: 90,  hip: 114.5 },
  { eu: 48, bust: 112, waist: 96,  hip: 120 },
  { eu: 50, bust: 118, waist: 102, hip: 125.5 },
  { eu: 52, bust: 124, waist: 108, hip: 131 },
  { eu: 54, bust: 130, waist: 114, hip: 136.5 },
  { eu: 56, bust: 136, waist: 120, hip: 142 },
  { eu: 58, bust: 142, waist: 126, hip: 147.5 },
  { eu: 60, bust: 148, waist: 132, hip: 153 }
];

const WOMEN_OLD = [ // EU 32–62 (alte Gradierung, um eine Größe versetzt)
  { eu: 32, bust: 82,  waist: 66,    hip: 91 },
  { eu: 34, bust: 85,  waist: 69,    hip: 94 },
  { eu: 36, bust: 88,  waist: 72,    hip: 97 },
  { eu: 38, bust: 92,  waist: 76,    hip: 101 },
  { eu: 40, bust: 96,  waist: 80,    hip: 105 },
  { eu: 42, bust: 100, waist: 84,    hip: 109 },
  { eu: 44, bust: 106, waist: 90.5,  hip: 115 },
  { eu: 46, bust: 112, waist: 97,    hip: 120 },
  { eu: 48, bust: 118, waist: 104,   hip: 126 },
  { eu: 50, bust: 124, waist: 110,   hip: 131 },
  { eu: 52, bust: 130, waist: 116,   hip: 136 },
  { eu: 54, bust: 138, waist: 125,   hip: 143.5 },
  { eu: 56, bust: 146, waist: 133.5, hip: 150.5 },
  { eu: 58, bust: 154, waist: 142,   hip: 157.5 },
  { eu: 60, bust: 162, waist: 150.2, hip: 164.5 },
  { eu: 62, bust: 170, waist: 159,   hip: 171.5 }
];

const MEN_SIZES = [ // EU 44–74 (unverändert)
  { eu: 44, bust: 88,  waist: 80,   hip: 95 },
  { eu: 46, bust: 92,  waist: 84,   hip: 98 },
  { eu: 48, bust: 96,  waist: 88,   hip: 101 },
  { eu: 50, bust: 100, waist: 92,   hip: 104 },
  { eu: 52, bust: 104, waist: 96.5, hip: 108 },
  { eu: 54, bust: 108, waist: 101,  hip: 111 },
  { eu: 56, bust: 112, waist: 106,  hip: 115 },
  { eu: 58, bust: 116, waist: 110,  hip: 118 },
  { eu: 60, bust: 120, waist: 115,  hip: 122 },
  { eu: 62, bust: 124, waist: 119,  hip: 125 },
  { eu: 64, bust: 128, waist: 124,  hip: 129 },
  { eu: 66, bust: 136, waist: 128,  hip: 132 },
  { eu: 68, bust: 141, waist: 134,  hip: 136 },
  { eu: 70, bust: 146, waist: 141,  hip: 140 },
  { eu: 72, bust: 151, waist: 147,  hip: 144 },
  { eu: 74, bust: 157, waist: 152,  hip: 148 }
];

// Weitere Körpermaße je Größe aus der SEAMONE-Konstruktionstabelle (Vorlagen/Koerpermasse).
// Gilt, wenn die Produkttabelle das Maß nicht selbst mitbringt (Felder arm, upperArm, thigh, calf).
const WOMEN_BODY = { // EU 30–60
  eu:       [30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60],
  bust:     [76, 79, 82, 85, 88, 92, 96, 100, 106, 112, 118, 124, 130, 136, 142, 148],
  hip:      [85, 88, 91, 94, 97, 101, 105, 109, 114.5, 120, 125.5, 131, 136.5, 142, 147.5, 153],
  arm:      [59.6, 59.7, 59.8, 59.9, 60, 60.2, 60.4, 60.6, 60.8, 61, 61.2, 61.4, 61.6, 61.8, 62, 62.2],
  upperArm: [24, 25, 26, 27, 28, 29.4, 30.8, 32.2, 34.2, 36.2, 38.2, 40.2, 42.2, 44.2, 46.2, 48.2],
  thigh:    [53, 54.4, 55.8, 57.2, 58.6, 60.4, 62.2, 64, 66.2, 68.4, 70.6, 72.8, 75, 77.2, 79.4, 81.6],
  calf:     [32.6, 33.2, 33.8, 34.4, 35, 35.8, 36.6, 37.4, 38.6, 39.8, 41, 42.2, 43.4, 44.6, 45.8, 47]
};
const MEN_BODY = { // EU 44–74
  eu:       [44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 66, 68, 70, 72, 74],
  bust:     [88, 92, 96, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 148],
  hip:      [96, 100, 104, 108, 111.5, 115, 118.5, 122, 125.5, 129, 132.5, 136, 139.5, 143, 146.5, 150],
  arm:      [60.7, 61.8, 62.9, 64, 64.8, 65.6, 66.4, 67.2, 68, 68.4, 68.8, 69.2, 69.6, 70, 70.4, 70.8],
  upperArm: [30.5, 32, 33.5, 35, 36.5, 38, 39.5, 41, 42.5, 44, 45.5, 47, 48.5, 50, 51.5, 53],
  thigh:    [54.5, 56, 57.5, 59, 60.5, 62, 63.5, 65, 66.5, 68, 69.5, 71, 72.5, 74, 75.5, 77],
  calf:     [35, 36, 37, 38, 39, 40, 41, 42, 43, 43.5, 44, 44.5, 45, 45.5, 46, 46.5]
};

// ===== EINSTELLUNGEN =====
const TOLERANCE = 1.6;      // Damen & Herren
const CUP_BASE = 4;         // B-Cup = 4 cm Differenz (BU - OBU)
const MIN_ADJUST = 1.0;     // FBA/SBA erst ab 1 cm Anpassung (= ab 2 cm Abweichung vom B-Cup)
const FBA_MAX = 5;          // größere FBA -> Maßanfertigung empfehlen
const SBA_MAX = 2;          // SBA höchstens 2 cm: (4 − Differenz) : 2, Differenz 0 -> 2 cm (Simo, Kvill-Anleitung S. 8)
const OBERBUST_HINT = 'Oberbrust ist größer als Brust – bitte beide Maße noch einmal messen (Oberbrust direkt unter den Achseln, Brust an der stärksten Stelle).';
const HEIGHT_MIN = 130, HEIGHT_MAX = 210; // plausible Körpergröße in cm (fängt 1,68 oder 1680 ab)

// ===== ZUSTAND =====
let currentCategory = 'women';
let currentSystem = 'new';   // 'new' oder 'old' (Damen); Herren ignoriert das
let measurements = {};

// Interaktive Maßtabelle der Produktseite (<script id="seamoneProductTableData">) -> Tabelle für den Rechner.
// Liest alle Körpermaße, die der Schnitt hat (Brust, Taille, Hüfte, Armlänge, Oberarm, Oberschenkel, Wade).
const BODY_FIELDS = [['bust', 'Brustumfang'], ['waist', 'Taillenumfang'], ['hip', 'Hüftumfang'], ['arm', 'Armlänge'],
  ['upperArm', 'Oberarmumfang'], ['thigh', 'Oberschenkelumfang'], ['calf', 'Wadenumfang'], ['height', 'Körperlänge']];
function tableFromProductData(P) {
  if (!P || !Array.isArray(P.eu_sizes)) return null;
  const num = v => v == null ? NaN : parseFloat(String(v).replace(/[^0-9,.\-]/g, '').replace(',', '.'));
  const bm = P.body_measurements || {}, t = [];
  P.eu_sizes.forEach((e, i) => {
    const eu = parseInt(String(e).replace(/[^0-9]/g, ''), 10);
    if (isNaN(eu)) return;
    const r = { eu };
    BODY_FIELDS.forEach(([k, f]) => { if (bm[f]) r[k] = num(bm[f][i]); });
    // Kinder: Altersangabe = UK/US-Größe (z. B. „18m“, „7“) aus „sizes“ der interaktiven Tabelle
    if (Array.isArray(P.sizes) && P.sizes[i] != null) r.age = String(P.sizes[i]).trim();
    t.push(r);
  });
  return t.length ? t : null;
}
function readProductData() {
  // Größenrechner-Seite: die Auswahl „Dein Schnitt“ legt die Daten des gewählten Schnitts hier ab
  if (typeof window !== 'undefined' && window.SEAMONE_PRODUCT_DATA) return window.SEAMONE_PRODUCT_DATA;
  if (typeof document === 'undefined') return null;
  try { const el = document.getElementById('seamoneProductTableData'); return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
}

// Aktive Tabelle bestimmen (Simo, 20.10.2026): die interaktive Maßtabelle des Schnitts hat immer Vorrang,
// dann die Produkt-Tabelle (Metafeld), sonst die allgemeine Tabelle (nur ohne ausgewählten Schnitt).
function getActiveTable() {
  const fromData = tableFromProductData(readProductData());
  if (fromData && fromData.some(r => !isNaN(r.hip))) return fromData;
  if (typeof window !== 'undefined' && window.SEAMONE_PRODUCT_TABLE && Array.isArray(window.SEAMONE_PRODUCT_TABLE)) {
    return window.SEAMONE_PRODUCT_TABLE;
  }
  if (currentCategory === 'men') return MEN_SIZES;
  return currentSystem === 'old' ? WOMEN_OLD : WOMEN_NEW;
}

// ===== KINDER (Simo, 02.11.2026) =====
// Kinderschnitte (z. B. Kalix Kinder, Größen 86–164 = Körperlänge): Größe nach Körpergröße – bei Zwischenwerten
// die nächstgrößere (Luft zum Wachsen), keine Längenanpassung. Weite nach Brust/Taille/Hüfte,
// höchstens zwei Größen neben der Längengröße. Keine Brustanpassung, keine Zusatzmaße.
const KIDS_TOLERANCE = 1.1;
function srIsKidsTable(table, name) {
  if (/kinder|kids|child/i.test(String(name || ''))) return true;
  return Array.isArray(table) && table.length > 0 && table.every(r => !isNaN(r.height) && Math.abs(r.eu - r.height) <= 1);
}
function computeKidsResult(input, table) {
  const pattern = input.pattern;
  const num = k => parseFloat(input[k]);
  const isBottom = (pattern === 'pants' || pattern === 'skirt');
  const isTop = !isBottom;
  const rows = table.slice().sort((a, b) => a.eu - b.eu);
  const hOf = r => isNaN(r.height) || r.height == null ? r.eu : r.height;
  const height = num('height');
  const lengthRow = rows.find(r => hOf(r) >= height) || rows[rows.length - 1];
  const li = rows.indexOf(lengthRow);

  measurements = {};
  const results = {};
  const capped = [];
  (isTop ? ['bust', 'waist', 'hip'] : ['hip', 'waist']).forEach(k => {
    const v = num(k);
    const col = rows.filter(x => !isNaN(x[k]) && x[k] != null);
    if (isNaN(v) || !col.length) return;
    measurements[k] = v;
    let r = findBestSize(col, v, k, KIDS_TOLERANCE);
    const i = rows.indexOf(r.finalSize);
    if (Math.abs(i - li) > 2) {                       // höchstens zwei Größen neben der Längengröße
      const row = rows[li + Math.sign(i - li) * 2];
      capped.push({ key: k, from: r.finalSize.eu, to: row.eu });
      r = Object.assign({}, r, { finalSize: row, adjustedFor2Size: true, difference: v - row[k] });
    }
    results[k] = r;
  });

  const uniqueSizes = [...new Set([lengthRow.eu, ...Object.values(results).map(r => r.finalSize.eu)])].sort((a, b) => a - b);
  const ages = {};
  rows.forEach(r => { if (r.age) ages[r.eu] = r.age; });
  return {
    kids: true, ages, category: 'kids', pattern, isTop, isBottom,
    baseKey: 'height', baseReason: 'nach Körpergröße', baseSize: lengthRow.eu, fbaBaseSize: null,
    cup: null, oberbustHint: null, length: null, belly: null, sleeve: null, warnings: [], body: null, waistCapped: null,
    kidsHeight: { height, eu: lengthRow.eu, ref: hOf(lengthRow) }, kidsCapped: capped,
    results, uniqueSizes
  };
}

// ===== KERN: beste Größe für ein Maß finden =====
function findBestSize(table, measurement, type, tolerance) {
  let closest = null, minDiff = Infinity;
  for (const size of table) {
    const d = Math.abs(size[type] - measurement);
    if (d < minDiff) { minDiff = d; closest = size; }
  }
  const originalDiff = measurement - closest[type];

  if (Math.abs(originalDiff) <= tolerance) {
    return { finalSize: closest, originalSize: closest, adjusted: false, adjustedFor2Size: false, difference: originalDiff };
  }

  // Außerhalb Toleranz: "optimaler Komfort" -> lieber etwas zu weit als zu eng
  let best = closest, bestDiff = originalDiff;
  for (const size of table) {
    const sizeDiff = measurement - size[type];
    if (sizeDiff < 0 && bestDiff > 0) { best = size; bestDiff = sizeDiff; }
    else if (sizeDiff < 0 && bestDiff < 0) { if (Math.abs(sizeDiff) < Math.abs(bestDiff)) { best = size; bestDiff = sizeDiff; } }
    else if (sizeDiff > 0 && bestDiff > 0) { if (Math.abs(sizeDiff) < Math.abs(bestDiff)) { best = size; bestDiff = sizeDiff; } }
  }
  return { finalSize: best, originalSize: closest, adjusted: true, adjustedFor2Size: false, difference: bestDiff };
}

// ===== 2-Größen-Regel (max. 2 Größen = 4 EU-Punkte Spanne) =====
function apply2SizeRule(results, table) {
  const sizes = Object.values(results).map(r => r.finalSize.eu);
  const min = Math.min(...sizes), max = Math.max(...sizes);
  if (max - min > 4) {
    const allowedMin = max - 4;
    Object.keys(results).forEach(key => {
      if (results[key].finalSize.eu < allowedMin) {
        const newSize = table.find(s => s.eu === allowedMin);
        if (newSize) {
          results[key] = {
            finalSize: newSize,
            originalSize: results[key].originalSize,
            adjusted: results[key].adjusted,
            adjustedFor2Size: true,
            difference: measurements[key] - newSize[key]
          };
        }
      }
    });
  }
  return results;
}

// ===== FBA/SBA bestimmen =====
function computeCup(bust, oberbust) {
  // optional / ungültig -> keine Cup-Anpassung (Oberbrust > Brust: Hinweis zum Nachmessen, siehe computeResult)
  if (isNaN(oberbust) || oberbust <= 0 || oberbust > bust) return null;
  const diff = bust - oberbust;                 // z.B. 92 - 84 = 8
  const adjust = (diff - CUP_BASE) / 2;          // z.B. (8-4)/2 = 2
  if (adjust >= MIN_ADJUST)  return { type: 'FBA', amount: adjust,  diff, bust, oberbust, tooBig: adjust > FBA_MAX };
  if (adjust <= -MIN_ADJUST) return { type: 'SBA', amount: Math.min(-adjust, SBA_MAX), diff, bust, oberbust };
  return { type: 'none', amount: 0, diff, bust, oberbust };
}

// Weitere Körpermaße der gewählten Größe: aus der Produkttabelle, sonst aus der Konstruktionstabelle
// (Zeile mit dem nächsten Brust- bzw. Hüftumfang, damit es auch für die alte Gradierung passt)
function bodyOfSize(row, isTop, category) {
  const B = category === 'men' ? MEN_BODY : WOMEN_BODY;
  const key = isTop ? 'bust' : 'hip';
  let gi = 0, gd = Infinity;
  B[key].forEach((v, i) => { const d = Math.abs(v - row[key]); if (d < gd) { gd = d; gi = i; } });
  const out = {};
  ['arm', 'upperArm', 'thigh', 'calf'].forEach(k => { out[k] = (row[k] != null && !isNaN(row[k])) ? row[k] : B[k][gi]; });
  return out;
}

// ===== REINE BERECHNUNG (ohne DOM, testbar) =====
function computeResult(input) {
  if (input.category === 'kids') return computeKidsResult(input, input.table || getActiveTable());
  const { category, pattern } = input;
  const bust = parseFloat(input.bust);
  const oberbust = parseFloat(input.oberbust);
  const waist = parseFloat(input.waist);
  const hip = parseFloat(input.hip);

  const table = input.table || getActiveTable();
  const isBottom = (pattern === 'pants' || pattern === 'skirt');
  const isTop = !isBottom;
  const isPants = pattern === 'pants';

  // Cup nur bei Oberteilen/Kleidern
  let cup = null;
  if (isTop) cup = computeCup(bust, oberbust);
  const fba = !!(cup && cup.type === 'FBA');
  // Oberbrust größer als Brust: vermutlich vertauscht/falsch gemessen -> keine Brustanpassung, Hinweis zum Nachmessen
  const oberbustHint = (isTop && !isNaN(oberbust) && oberbust > 0 && oberbust > bust) ? OBERBUST_HINT : null;

  // Grundgröße
  measurements = { hip };
  const results = {};
  let baseKey, baseReason;

  if (isTop) {
    // Bei FBA zählt Oberbrust + 4 cm als Brustmaß (Schulter & Rahmen); die Mehrweite kommt über die FBA
    measurements.bust = fba ? oberbust + CUP_BASE : bust;
    measurements.waist = waist;
    results.bust = findBestSize(table, measurements.bust, 'bust', TOLERANCE);
    results.waist = findBestSize(table, waist, 'waist', TOLERANCE);
    results.hip = findBestSize(table, hip, 'hip', TOLERANCE);
    baseKey = 'bust';
    baseReason = fba ? 'nach Oberbrustumfang + 4 cm' : 'nach Brustumfang';
  } else if (isPants) {
    // Hose: Größe nach Hüftumfang; die Taille wird erkannt (Simo, 22.10.2026) – liegt sie in einer anderen Größe,
    // wird die Weite oben bis zu 2 Größen angeglichen (wie bei Oberteilen)
    results.hip = findBestSize(table, hip, 'hip', TOLERANCE);
    if (!isNaN(waist) && waist > 0) { measurements.waist = waist; results.waist = findBestSize(table, waist, 'waist', TOLERANCE); }
    baseKey = 'hip';
    baseReason = 'nach Hüftumfang';
  } else {
    measurements.waist = waist;
    results.hip = findBestSize(table, hip, 'hip', TOLERANCE);
    results.waist = findBestSize(table, waist, 'waist', TOLERANCE);
    baseKey = 'hip';
    baseReason = 'nach Hüftumfang';
  }

  // Hose: die Hüftgröße bleibt; liegt die Taille mehr als 2 Größen daneben, wird sie auf 2 Größen begrenzt (Hinweis)
  let waistCapped = null;
  if (isPants && results.waist) {
    const he = results.hip.finalSize.eu, we = results.waist.finalSize.eu;
    if (Math.abs(we - he) > 4) {
      const ce = he + Math.sign(we - he) * 4, row = table.find(s => s.eu === ce);
      if (row) { waistCapped = { from: we, to: ce }; results.waist = { ...results.waist, finalSize: row, adjustedFor2Size: true, difference: waist - row.waist }; }
    }
  } else apply2SizeRule(results, table);

  const sizeRow = results[baseKey].finalSize;
  const baseSize = sizeRow.eu;

  // Hose: Taille größer als der Hüftumfang der Größe -> Bauchanpassung
  let belly = null;
  if (isPants && !isNaN(waist) && waist > sizeRow.hip) belly = { waist, hip: sizeRow.hip, eu: baseSize };

  // Längen-Hinweis (halbiert, außer Kleid = volle Differenz)
  let length = null;
  const height = parseFloat(input.height);
  if (!isNaN(height)) {
    if (height < HEIGHT_MIN || height > HEIGHT_MAX) {
      length = { invalid: true, height };
    } else {
      // the pattern's own height if the designer gave one – one for all sizes, or per size ({EU: cm}) from her size chart
      const ref = (input.refHeight && typeof input.refHeight === 'object' ? input.refHeight[baseSize] : input.refHeight) || (category === 'men' ? 180 : 168);
      const diff = height - ref; // + = größer
      // Kleid (Simo, 22.10.2026): volle Differenz, halb auf den Oberkörper, halb auf den Rock
      const amount = (pattern === 'dress') ? Math.abs(diff) : Math.abs(diff) / 2;
      length = {
        ref, height, diff, amount,
        upper: (pattern === 'dress') ? Math.abs(diff) / 2 : null,
        lower: (pattern === 'dress') ? Math.abs(diff) / 2 : null,
        direction: diff > 0 ? 'verlängern' : (diff < 0 ? 'kürzen' : null),
        needed: diff !== 0
      };
    }
  }

  // Weitere Körpermaße der Größe (Armlänge, Oberarm, Oberschenkel, Wade)
  const body = bodyOfSize(sizeRow, isTop, category);

  // Armlänge (optional): Ärmel nach der eigenen Armlänge statt nach der Körpergröße
  let sleeve = null;
  const arm = parseFloat(input.arm);
  if (isTop && !isNaN(arm) && arm > 0) {
    const diff = arm - body.arm;
    sleeve = { arm, ref: body.arm, eu: baseSize, diff, amount: Math.abs(diff),
      direction: diff > 0 ? 'verlängern' : 'kürzen', needed: Math.abs(diff) >= 0.5 };
  }

  // Oberarm / Oberschenkel / Wade (optional): nur Warnung, wenn es eng werden kann
  const warnings = [];
  const check = (key, label, val) => {
    val = parseFloat(val);
    if (!isNaN(val) && val - body[key] > TOLERANCE) warnings.push({ key, label, yours: val, body: body[key], eu: baseSize, diff: val - body[key] });
  };
  if (isTop) check('upperArm', 'Oberarmumfang', input.upperArm);
  if (isPants) { check('thigh', 'Oberschenkelumfang', input.thigh); check('calf', 'Wadenumfang', input.calf); }

  const uniqueSizes = [...new Set(Object.values(results).map(r => r.finalSize.eu))].sort((a, b) => a - b);

  return {
    category, pattern, isTop, isBottom,
    baseKey, baseReason, baseSize, fbaBaseSize: fba ? baseSize : null,
    cup, oberbustHint, length, belly, sleeve, warnings, body, waistCapped,
    results,
    uniqueSizes
  };
}

// Kinder: Körpergröße ist Pflicht (sie bestimmt die Größe) und muss zur Tabelle passen; keine Erwachsenen-Grenzen 130–210 cm
function srValidateKids(table, isTop, bust, waist, hip, opts) {
  const span = (type) => {
    const vals = table.map(s => type === 'height' && isNaN(s.height) ? s.eu : s[type]).filter(v => v != null && !isNaN(v));
    return { min: Math.min(...vals) - (type === 'height' ? 10 : 3), max: Math.max(...vals) + (type === 'height' ? 10 : 3) };
  };
  const out = (v, s) => isNaN(v) || v < s.min || v > s.max;
  const OUT = srT(' – außerhalb unseres Größenangebots', ' – outside our size range');
  const errors = [];
  const h = parseFloat(opts.height);
  if (isNaN(h)) errors.push(srT('Körpergröße – bei Kindern bitte immer angeben, danach richtet sich die Größe', 'Height – always needed for children, the size is based on it'));
  else if (out(h, span('height'))) errors.push(srT('Körpergröße', 'Height') + OUT);
  if (isTop && out(bust, span('bust'))) errors.push(srT('Brustumfang', 'Chest') + OUT);
  if (out(waist, span('waist'))) errors.push(srT('Taillenumfang', 'Waist') + OUT);
  if (out(hip, span('hip'))) errors.push(srT('Hüftumfang', 'Hip') + OUT);
  return errors;
}

// ===== VALIDIERUNG (aus aktiver Tabelle abgeleitet) =====
// opts: { pattern, oberbust, height } – liefert fertige Hinweistexte
function validateInput(table, isTop, bust, waist, hip, opts) {
  opts = opts || {};
  if (opts.kids) return srValidateKids(table, isTop, bust, waist, hip, opts);
  const span = (type) => {
    const vals = table.map(s => s[type]).filter(v => !isNaN(v));
    return { min: Math.min(...vals) - 3, max: Math.max(...vals) + 3 };
  };
  const out = (v, s) => isNaN(v) || v < s.min || v > s.max;
  const OUT = srT(' – außerhalb unseres Größenangebots', ' – outside our size range');
  const errors = [];
  const ob = parseFloat(opts.oberbust);
  if (isTop) {
    // mit FBA wird nach Oberbrust + 4 cm gewählt, dann muss die volle Brust nicht in der Tabelle liegen
    const cup = computeCup(bust, ob);
    const b = (cup && cup.type === 'FBA') ? ob + CUP_BASE : bust;
    if (out(b, span('bust'))) errors.push((cup && cup.type === 'FBA' ? srT('Oberbrustumfang', 'High bust') : srT('Brustumfang', 'Bust')) + OUT);
    if (out(waist, span('waist'))) errors.push(srT('Taillenumfang', 'Waist') + OUT);
  } else if (opts.pattern !== 'pants') {
    if (out(waist, span('waist'))) errors.push(srT('Taillenumfang', 'Waist') + OUT);
  }
  if (out(hip, span('hip'))) errors.push(srT('Hüftumfang', 'Hip') + OUT);
  const h = parseFloat(opts.height);
  if (!isNaN(h) && (h < HEIGHT_MIN || h > HEIGHT_MAX)) errors.push(srT('Körpergröße – bitte in cm angeben, z. B. 168', 'Height – please enter it in cm, e.g. 168'));
  return errors;
}

// ===== AUSGABE (neu 20.10.2026: übersichtlich, SEAMONE-Optik, als PDF speicher- und druckbar) =====
// Optik: SEAMONE Navy #232941, Gold #A9997D, Fläche #F2F1EC. Das CSS steckt hier im Code, das Theme braucht keine Extra-Datei.
const SR_CSS = `
.sr-report{--sr-navy:#232941;--sr-gold:#A9997D;--sr-bg:#F2F1EC;--sr-line:#E2DED3;--sr-warn:#9A5B2E;
  font-family:Inter,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Arial,sans-serif;color:var(--sr-navy);font-size:14px;line-height:1.5;text-align:left}
.sr-report *{box-sizing:border-box}
.sr-head{display:flex;justify-content:space-between;align-items:baseline;gap:12px;flex-wrap:wrap;border-bottom:1px solid var(--sr-line);padding-bottom:10px;margin-bottom:16px}
.sr-brand{font-weight:700;letter-spacing:.28em;font-size:15px}
.sr-meta{font-size:12px;color:#6B6E7E}
.sr-size{background:var(--sr-navy);color:#fff;border-radius:10px;padding:18px 20px;display:grid;grid-template-columns:1fr auto;align-items:center;gap:2px 16px}
.sr-size-l{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--sr-gold)}
.sr-size-v{grid-row:span 2;font-size:34px;font-weight:700;letter-spacing:.02em;white-space:nowrap}
.sr-size-r{font-size:13px;color:#D9D6CC}
.sr-alert{margin-top:12px;border:1px solid var(--sr-warn);background:#FBF3EC;color:var(--sr-warn);border-radius:8px;padding:10px 14px}
.sr-h{font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:var(--sr-gold);font-weight:600;margin:22px 0 8px}
.sr-steps{list-style:none;margin:0;padding:0;display:grid;gap:8px}
.sr-step{background:var(--sr-bg);border-radius:8px;padding:10px 14px 10px 46px;position:relative}
.sr-step::before{content:attr(data-n);position:absolute;left:12px;top:10px;width:24px;height:24px;border-radius:50%;background:var(--sr-navy);color:#fff;font-size:12px;font-weight:600;display:flex;align-items:center;justify-content:center}
.sr-step b{display:block;font-size:14px}
.sr-step span{display:block;color:#4A4D5C;font-size:13px}
.sr-step.sr-opt::before{background:var(--sr-gold)}
.sr-step.sr-warn{background:#FBF3EC}.sr-step.sr-warn::before{content:'!';background:var(--sr-warn)}
.sr-table{width:100%;border-collapse:collapse;font-size:13px}
.sr-table th{font-weight:600;text-align:left;font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:#6B6E7E;border-bottom:1px solid var(--sr-line);padding:6px 6px 6px 0}
.sr-table td{border-bottom:1px solid var(--sr-line);padding:7px 6px 7px 0;vertical-align:top}
.sr-table td.n{text-align:right;white-space:nowrap}.sr-table th.n{text-align:right}
.sr-foot{margin-top:18px;font-size:12px;color:#6B6E7E;border-top:1px solid var(--sr-line);padding-top:10px}
.sr-actions{display:flex;gap:8px;flex-wrap:wrap;margin-top:16px}
.sr-btn{font:inherit;font-weight:600;font-size:14px;border-radius:6px;padding:11px 18px;cursor:pointer;border:1px solid var(--sr-navy);background:var(--sr-navy);color:#fff}
.sr-btn.sr-sec{background:transparent;color:var(--sr-navy)}
@media (max-width:480px){.sr-size-v{font-size:28px}.sr-table th:nth-child(4),.sr-table td:nth-child(4){display:none}}
@media print{.sr-actions{display:none}.sr-report{font-size:12px}.sr-step{break-inside:avoid}
  /* tintensparend (Simo 20.10.2026): keine dunklen Flächen, nur Rahmen */
  .sr-size{background:#fff;color:var(--sr-navy);border:1.5px solid var(--sr-navy)}.sr-size-r{color:#4A4D5C}
  .sr-step,.sr-step.sr-warn,.sr-alert{background:#fff;border:1px solid var(--sr-line)}.sr-step.sr-warn,.sr-alert{border-color:var(--sr-warn)}
  .sr-step::before{background:#fff;color:var(--sr-navy);border:1.5px solid var(--sr-navy)}
  .sr-step.sr-opt::before{background:#fff;color:var(--sr-gold);border-color:var(--sr-gold)}
  .sr-step.sr-warn::before{background:#fff;color:var(--sr-warn);border-color:var(--sr-warn)}}
`;

function srInjectCss(doc) {
  doc = doc || document;
  if (doc.getElementById('sr-css')) return;
  const s = doc.createElement('style'); s.id = 'sr-css'; s.textContent = SR_CSS; doc.head.appendChild(s);
}

// Sprache: Englisch, wenn die Shopseite englisch ist (<html lang="en">, z. B. seamone.de/en/…), sonst Deutsch
function srIsEnglish() {
  return typeof document !== 'undefined' && /^en/i.test((document.documentElement && document.documentElement.lang) || '');
}
function srT(de, en) { return srIsEnglish() ? en : de; }

// Ergebnis für Kinderschnitte (gleiche Optik, eigener Inhalt: Größe = Körpergröße, Weite eventuell aus anderer Größe)
function srKidsReport(res, ctx) {
  ctx = ctx || {};
  const en = srIsEnglish();
  const T = (de, e) => en ? e : de;
  const fmt = (n) => { const s = (Math.round(n * 10) / 10).toString(); return en ? s : s.replace('.', ','); };
  const cm = (n) => `${fmt(n)} cm`;
  const dev = (d) => `${d > 0 ? '+' : d < 0 ? '−' : '±'}${fmt(Math.abs(d))} cm`;
  const date = new Date().toLocaleDateString(en ? 'en-GB' : 'de-DE');
  const K = res.kidsHeight;
  // Altersangabe zur Größe: Deutsch „ca. 7 Jahre“ / „ca. 18 Monate“, Englisch „UK/US 7“
  const age = (eu) => {
    const a = res.ages && res.ages[eu];
    if (!a || !/^\d+\s*m?$/i.test(a)) return '';
    if (en) return `UK/US ${a}`;
    const n = parseInt(a, 10);
    return /m$/i.test(a) ? `ca. ${n} Monate` : `ca. ${n} ${n === 1 ? 'Jahr' : 'Jahre'}`;
  };
  const euA = (eu) => age(eu) ? `EU ${eu} (${age(eu)})` : `EU ${eu}`;
  const labels = { bust: T('Brustumfang', 'Chest'), waist: T('Taillenumfang', 'Waist'), hip: T('Hüftumfang', 'Hip') };
  const short = { bust: T('Brust', 'Chest'), waist: T('Taille', 'Waist'), hip: T('Hüfte', 'Hip') };
  const steps = [];
  const add = (title, text, cls) => steps.push({ title, text, cls: cls || '' });

  const widthKeys = Object.keys(res.results).filter(k => res.results[k].finalSize.eu !== res.baseSize);
  if (widthKeys.length) {
    const per = Object.keys(res.results).map(k => `${short[k]} EU ${res.results[k].finalSize.eu}`).join(' · ');
    add(T(`Weite: EU ${res.uniqueSizes.join(' und EU ')} verbinden`, `Width: blend EU ${res.uniqueSizes.join(' and EU ')}`),
      T(`Länge aus EU ${res.baseSize} (Längenlinien, Saum, Ärmellänge), Weite: ${per}. Blende die Größen ein und zeichne an der Seitennaht einen gleitenden Übergang (höchstens zwei Größen).`,
        `Length from EU ${res.baseSize} (lengthen/shorten lines, hem, sleeve length), width: ${per}. Show the sizes and draw a smooth transition at the side seam (no more than two sizes).`)
      + [...new Set((res.kidsCapped || []).map(c => c.from))].map(eu => {
        const names = res.kidsCapped.filter(c => c.from === eu).map(c => short[c.key]);
        const list = names.length > 1 ? names.slice(0, -1).join(', ') + T(' und ', ' and ') + names[names.length - 1] : names[0];
        return T(` ${list} ${names.length > 1 ? 'liegen' : 'liegt'} eigentlich bei EU ${eu} – mehr als zwei Größen von der Länge entfernt: bitte zusätzlich anpassen.`,
          ` ${list} would be EU ${eu} – more than two sizes from the length: please adjust further.`);
      }).join(''));
  }
  add(T('Länge: keine Anpassung nötig', 'Length: no adjustment needed'),
    T(`Bei Kindern richtet sich die Größe nach der Körpergröße. EU ${res.baseSize} passt für ${cm(K.height)}` + (K.height < K.ref ? ' – mit etwas Luft zum Wachsen.' : '.'),
      `For children the size is based on height. EU ${res.baseSize} fits ${cm(K.height)}` + (K.height < K.ref ? ' – with a little room to grow.' : '.')), 'sr-opt');

  let n = 0;
  const stepsHtml = steps.map(s => `<li class="sr-step ${s.cls}" data-n="${s.cls ? '' : ++n}"><b>${s.title}</b><span>${s.text}</span></li>`).join('');

  const rows = [[T('Körpergröße', 'Height'), cm(K.height), `EU ${res.baseSize}: ${cm(K.ref)}`, dev(K.height - K.ref)]];
  Object.keys(res.results).forEach(k => {
    const r = res.results[k];
    rows.push([labels[k], cm(measurements[k]), `EU ${r.finalSize.eu}: ${cm(r.finalSize[k])}`, dev(r.difference)]);
  });

  return `<div class="sr-report" lang="${en ? 'en' : 'de'}">
  <div class="sr-head"><div class="sr-brand">SEAMONE</div><div class="sr-meta">${T('Dein Größenergebnis', 'Your size result')}${ctx.name ? ' · ' + ctx.name : ''} · ${date}</div></div>
  <div class="sr-size"><div class="sr-size-l">${T('Größe deines Kindes', 'Your child’s size')}</div><div class="sr-size-v">EU ${res.baseSize}</div><div class="sr-size-r">${T(`nach Körpergröße (${cm(K.height)})`, `based on height (${cm(K.height)})`)}${age(res.baseSize) ? ' · ' + age(res.baseSize) : ''}</div></div>
  <div class="sr-h">${T('So passt du deinen Schnitt an', 'How to adjust your pattern')}</div>
  <ol class="sr-steps">${stepsHtml}</ol>
  <div class="sr-h">${T('Maße im Vergleich', 'Measurements compared')}</div>
  <table class="sr-table"><thead><tr><th>${T('Maß', 'Measurement')}</th><th class="n">${T('Gemessen', 'Measured')}</th><th class="n">${T('Maßtabelle', 'Size chart')}</th><th class="n">${T('Abweichung', 'Difference')}</th></tr></thead>
  <tbody>${rows.map(r => `<tr><td>${r[0]}</td><td class="n">${r[1]}</td><td class="n">${r[2]}</td><td class="n">${r[3]}</td></tr>`).join('')}</tbody></table>
  <div class="sr-foot">${T('Benötigte Schnittmuster-Größen', 'Pattern sizes needed')}: <b>${res.uniqueSizes.map(euA).join(', ')}</b>. ${T('Ausführliche Anleitungen findest du in der Nähanleitung zu deinem Schnitt.', 'You’ll find detailed instructions in the sewing instructions for your pattern.')} · seamone.de</div>
  <div class="sr-actions"><button type="button" class="sr-btn" onclick="seamonePrintResult(this)">${T('Als PDF speichern oder drucken', 'Save as PDF or print')}</button></div>
</div>`;
}

function generateReport(res, ctx) {
  if (res && res.kids) return srKidsReport(res, ctx);
  ctx = ctx || {};
  const inp = ctx.inputs || {};
  const en = srIsEnglish();
  const T = (de, e) => en ? e : de;
  const fmt = (n) => { const s = (Math.round(n * 10) / 10).toString(); return en ? s : s.replace('.', ','); };
  const cm = (n) => `${fmt(n)} cm`;
  const dev = (d) => `${d > 0 ? '+' : d < 0 ? '−' : '±'}${fmt(Math.abs(d))} cm`;
  const dir = (d) => d > 0 ? T('verlängern', 'lengthen') : T('kürzen', 'shorten');
  const fba = res.cup && res.cup.type === 'FBA';
  const labels = { bust: T('Brustumfang', 'Bust'), waist: T('Taillenumfang', 'Waist'), hip: T('Hüftumfang', 'Hip') };
  const date = new Date().toLocaleDateString(en ? 'en-GB' : 'de-DE');
  const reason = res.baseKey === 'bust' ? (fba ? T('nach Oberbrustumfang + 4 cm', 'based on high bust + 4 cm') : T('nach Brustumfang', 'based on bust'))
    : T('nach Hüftumfang', 'based on hip');
  const steps = [];
  const add = (title, text, cls) => steps.push({ title, text, cls: cls || '' });

  // 1. Weite
  if (res.uniqueSizes.length > 1) {
    const short = { bust: fba ? T('Oberbrust', 'High bust') : T('Brust', 'Bust'), waist: T('Taille', 'Waist'), hip: T('Hüfte', 'Hip') };
    const per = Object.keys(res.results).map(k => `${short[k]} EU ${res.results[k].finalSize.eu}`).join(' · ');
    add(T(`Weite: EU ${res.uniqueSizes.join(' und EU ')} verbinden`, `Width: blend EU ${res.uniqueSizes.join(' and EU ')}`),
      res.pattern === 'pants'
        ? T(`${per}. Blende beide Größen ein: oben (Bund, Tasche) die Taillengröße, ab der Hüfte EU ${res.baseSize}; an Seitennaht und Mitte einen gleitenden Übergang zeichnen (höchstens zwei Größen).`,
            `${per}. Show both sizes: at the top (waistband, pocket) your waist size, from the hip down EU ${res.baseSize}; draw a smooth transition at the side seam and centre (no more than two sizes).`)
          + (res.waistCapped ? T(` Deine Taille liegt bei EU ${res.waistCapped.from} – mehr als zwei Größen: bitte zusätzlich anpassen oder eine Maßanfertigung wählen.`,
            ` Your waist is EU ${res.waistCapped.from} – more than two sizes apart: please adjust further or choose a made-to-measure pattern.`) : '')
        : T(`${per}. Blende beide Größen ein und zeichne an der Seitennaht einen gleitenden Übergang (höchstens zwei Größen).`,
            `${per}. Show both sizes and draw a smooth transition at the side seam (no more than two sizes).`));
  }
  // 2. Brust
  if (res.cup && res.cup.tooBig) {
    // als Hinweis oben, kein Schritt
  } else if (res.cup && res.cup.type !== 'none') {
    const up = res.cup.type === 'FBA';
    add(T(`Brustanpassung (${res.cup.type}): Vorderteil um ${cm(res.cup.amount)} ${up ? 'erweitern' : 'verringern'}`,
          `Bust adjustment (${res.cup.type}): ${up ? 'enlarge' : 'reduce'} the front by ${cm(res.cup.amount)}`),
      T(`Differenz Brust zu Oberbrust ${cm(res.cup.diff)} (B-Körbchen = 4 cm). So geht es: siehe Nähanleitung zu deinem Schnitt.`,
        `Difference between bust and high bust ${cm(res.cup.diff)} (B cup = 4 cm). How to do it: see the sewing instructions for your pattern.`));
  }
  // 3. Bauch
  if (res.belly) {
    add(T('Bauchanpassung am Vorderteil', 'Tummy adjustment on the front'),
      T(`Dein Taillenumfang (${cm(res.belly.waist)}) ist größer als der Hüftumfang von EU ${res.belly.eu} (${cm(res.belly.hip)}).`,
        `Your waist (${cm(res.belly.waist)}) is larger than the hip measurement of EU ${res.belly.eu} (${cm(res.belly.hip)}).`));
  }
  // 4. Länge
  if (res.length && !res.length.invalid && res.length.needed) {
    const L = res.length;
    if (res.pattern === 'dress') {
      const ob = res.sleeve ? T('Vorderteil und Rückteil', 'front and back') : T('Vorderteil, Rückteil und Ärmel', 'front, back and sleeves');
      add(T(`Länge: Kleid insgesamt um ${cm(L.amount)} ${dir(L.diff)}`, `Length: ${dir(L.diff)} the dress by ${cm(L.amount)} in total`),
        T(`Halb Oberkörper, halb Rock: Oberkörper (${ob}) um ${cm(L.upper)}, Rock um ${cm(L.lower)}. Deine Körpergröße ${cm(L.height)}, der Schnitt ist für ${cm(L.ref)} konstruiert. Je Teil bis 4 cm an den unteren zwei Längenlinien, darüber gleichmäßig auf alle drei verteilen.`,
          `Half on the bodice, half on the skirt: bodice (${ob}) by ${cm(L.upper)}, skirt by ${cm(L.lower)}. Your height ${cm(L.height)}, the pattern is drafted for ${cm(L.ref)}. For each part, up to 4 cm use the lower two lengthen/shorten lines, above that spread the amount evenly over all three.`));
    } else {
    const was = res.pattern === 'pants' ? T('Hosenteile', 'trouser pieces') : res.pattern === 'skirt' ? T('Rockteile', 'skirt pieces')
      : res.pattern === 'dress' ? T('Kleid', 'dress') : (res.sleeve ? T('Vorderteil und Rückteil', 'front and back') : T('Vorderteil, Rückteil und Ärmel', 'front, back and sleeves'));
    add(T(`Länge: ${was} um ${cm(L.amount)} ${dir(L.diff)}`, `Length: ${dir(L.diff)} the ${was} by ${cm(L.amount)}`),
      T(`Deine Körpergröße ${cm(L.height)}, der Schnitt ist für ${cm(L.ref)} konstruiert. Bis 4 cm an den unteren zwei Längenlinien, darüber gleichmäßig auf alle drei verteilen.`,
        `Your height ${cm(L.height)}, the pattern is drafted for ${cm(L.ref)}. Up to 4 cm use the lower two lengthen/shorten lines, above that spread the amount evenly over all three.`));
    }
  }
  // 5. Ärmel
  if (res.sleeve && res.sleeve.needed) {
    add(T(`Ärmel um ${cm(res.sleeve.amount)} ${dir(res.sleeve.diff)}`, `${en ? dir(res.sleeve.diff).replace(/^./, c => c.toUpperCase()) : ''} the sleeves by ${cm(res.sleeve.amount)}`),
      T(`Nach deiner Armlänge (${cm(res.sleeve.arm)}, Körpermaß EU ${res.sleeve.eu}: ${cm(res.sleeve.ref)}) – statt der Längenanpassung am Ärmel.`,
        `Based on your arm length (${cm(res.sleeve.arm)}, body measurement EU ${res.sleeve.eu}: ${cm(res.sleeve.ref)}) – instead of the length adjustment on the sleeve.`));
  }
  // 6. Schrittkurve (bei Bedarf)
  if (res.pattern === 'pants') add(T('Bei Bedarf: Schrittkurve', 'If needed: crotch curve'),
    T('An ein flacheres oder runderes Gesäß anpassen, vorne an den Unterbauch (siehe Nähanleitung zu deinem Schnitt).',
      'Adjust for a flatter or rounder seat, at the front for the lower tummy (see the sewing instructions for your pattern).'), 'sr-opt');
  // Warnungen
  const wl = { upperArm: T('Oberarmumfang', 'Upper arm'), thigh: T('Oberschenkelumfang', 'Thigh'), calf: T('Wadenumfang', 'Calf') };
  (res.warnings || []).forEach(w => add(T(`Achtung ${wl[w.key] || w.label}: kann zu eng werden`, `Note – ${wl[w.key] || w.label}: may be too tight`),
    T(`Dein Maß ${cm(w.yours)}, Körpermaß EU ${w.eu}: ${cm(w.body)} (${dev(w.diff)}). Vergleiche mit den Fertigmaßen in der Maßtabelle.`,
      `Your measurement ${cm(w.yours)}, body measurement EU ${w.eu}: ${cm(w.body)} (${dev(w.diff)}). Compare with the finished measurements in the size chart.`), 'sr-warn'));

  let n = 0;
  const stepsHtml = steps.length
    ? steps.map(s => `<li class="sr-step ${s.cls}" data-n="${s.cls ? '' : ++n}"><b>${s.title}</b><span>${s.text}</span></li>`).join('')
    : `<li class="sr-step" data-n="✓"><b>${T('Keine Anpassung nötig', 'No adjustment needed')}</b><span>${T(`Du kannst den Schnitt in EU ${res.baseSize} so zuschneiden.`, `You can cut the pattern in EU ${res.baseSize} as it is.`)}</span></li>`;

  // Maße im Vergleich
  const rows = [];
  Object.keys(res.results).forEach(k => {
    const r = res.results[k];
    const name = k === 'bust' && fba ? T('Oberbrust + 4 cm', 'High bust + 4 cm') : labels[k];
    rows.push([name, cm(measurements[k]), `EU ${r.finalSize.eu}: ${cm(r.finalSize[k])}`, dev(r.difference)]);
  });
  if (fba || (res.cup && res.cup.type === 'SBA')) rows.push([labels.bust, cm(res.cup.bust), '–', '']);
  if (res.length && !res.length.invalid) rows.push([T('Körpergröße', 'Height'), cm(res.length.height), `${T('Schnitt', 'Pattern')}: ${cm(res.length.ref)}`, dev(res.length.diff)]);
  if (res.sleeve) rows.push([T('Armlänge', 'Arm length'), cm(res.sleeve.arm), `EU ${res.sleeve.eu}: ${cm(res.sleeve.ref)}`, dev(res.sleeve.diff)]);
  Object.keys(wl).forEach(k => { const v = parseFloat(inp[k]); if (!isNaN(v) && res.body && res.body[k] != null) rows.push([wl[k], cm(v), `EU ${res.baseSize}: ${cm(res.body[k])}`, dev(v - res.body[k])]); });

  const alerts = [];
  if (res.cup && res.cup.tooBig) alerts.push(T(`<b>Brustanpassung ${cm(res.cup.amount)}:</b> Bei mehr als ${FBA_MAX} cm empfehlen wir dir eine Maßanfertigung.`,
    `<b>Bust adjustment ${cm(res.cup.amount)}:</b> For more than ${FBA_MAX} cm we recommend a made-to-measure pattern.`));
  if (res.length && res.length.invalid) alerts.push(T('Bitte prüfe deine Körpergröße – bitte in cm angeben, z. B. 168.', 'Please check your height – enter it in cm, e.g. 168.'));
  if (res.oberbustHint) alerts.push(T(OBERBUST_HINT, 'Your high bust is larger than your bust – please measure both again (high bust directly under the arms, bust at the fullest point).'));

  return `<div class="sr-report" lang="${en ? 'en' : 'de'}">
  <div class="sr-head"><div class="sr-brand">SEAMONE</div><div class="sr-meta">${T('Dein Größenergebnis', 'Your size result')}${ctx.name ? ' · ' + ctx.name : ''} · ${date}</div></div>
  <div class="sr-size"><div class="sr-size-l">${T('Deine Ausgangsgröße', 'Your starting size')}</div><div class="sr-size-v">EU ${res.baseSize}</div><div class="sr-size-r">${reason}</div></div>
  ${alerts.map(a => `<div class="sr-alert">${a}</div>`).join('')}
  <div class="sr-h">${T('So passt du deinen Schnitt an', 'How to adjust your pattern')}</div>
  <ol class="sr-steps">${stepsHtml}</ol>
  <div class="sr-h">${T('Deine Maße im Vergleich', 'Your measurements compared')}</div>
  <table class="sr-table"><thead><tr><th>${T('Maß', 'Measurement')}</th><th class="n">${T('Dein Maß', 'Yours')}</th><th class="n">${T('Maßtabelle', 'Size chart')}</th><th class="n">${T('Abweichung', 'Difference')}</th></tr></thead>
  <tbody>${rows.map(r => `<tr><td>${r[0]}</td><td class="n">${r[1]}</td><td class="n">${r[2]}</td><td class="n">${r[3]}</td></tr>`).join('')}</tbody></table>
  <div class="sr-foot">${T('Benötigte Schnittmuster-Größen', 'Pattern sizes needed')}: <b>EU ${res.uniqueSizes.join(', EU ')}</b>. ${T('Ausführliche Anleitungen findest du in der Nähanleitung zu deinem Schnitt.', 'You’ll find detailed instructions in the sewing instructions for your pattern.')} · seamone.de</div>
  <div class="sr-actions"><button type="button" class="sr-btn" onclick="seamonePrintResult(this)">${T('Als PDF speichern oder drucken', 'Save as PDF or print')}</button></div>
</div>`;
}

// Druckt nur das Ergebnis (im Druckdialog „Als PDF speichern“ wählen)
function seamonePrintResult(btn) {
  const rep = btn && btn.closest ? btn.closest('.sr-report') : document.querySelector('.sr-report');
  if (!rep) return;
  const f = document.createElement('iframe');
  f.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0';
  document.body.appendChild(f);
  const d = f.contentDocument;
  d.open();
  d.write(`<!doctype html><html lang="${rep.getAttribute('lang') || 'de'}"><head><meta charset="utf-8"><title>SEAMONE ${rep.getAttribute('lang') === 'en' ? 'size result' : 'Größenergebnis'}</title><style>@page{size:A4;margin:0}body{margin:0;padding:16mm}${SR_CSS}</style></head><body>${rep.outerHTML}</body></html>`);
  d.close();
  setTimeout(() => { f.contentWindow.focus(); f.contentWindow.print(); setTimeout(() => f.remove(), 1000); }, 300);
}

// alter Name (Aufrufe in der App und älteren Theme-Teilen)
function generateOutput(res, ctx) { return generateReport(res, ctx); }

// ===== DOM-ANBINDUNG =====
function calculateSize() {
  const val = (id) => document.getElementById(id)?.value;
  const bust = val('bust');
  const oberbust = val('oberbust'); // optionales Feld (Schritt 2)
  const waist = val('waist');
  const hip = val('hip');
  const height = val('height');
  const arm = val('arm');           // optionale Felder (Überarbeitung 10/2026), fehlen sie im Theme, bleiben sie leer
  const upperArm = val('upperArm');
  const thigh = val('thigh');
  const calf = val('calf');
  const pattern = val('pattern') || 'top';
  const isBottom = (pattern === 'pants' || pattern === 'skirt');
  const isTop = !isBottom;

  // Ohne Schnitt keine Rechnung (Simo, 20.10.2026): nur die Maßtabelle des Schnitts ergibt die richtige Größe
  if (!hasPatternSelected()) return showError(srNoPatternMsg());
  const table = getActiveTable();
  const kids = srIsKidsTable(table, srPatternName());   // Kinderschnitt: Größe nach Körpergröße
  const category = kids ? 'kids' : currentCategory;
  if (isNaN(parseFloat(waist)) || isNaN(parseFloat(hip))) return showError(srT('Bitte Taillen- und Hüftumfang eingeben.', 'Please enter your waist and hip measurements.'));
  if (isTop && isNaN(parseFloat(bust))) return showError(srT('Brustumfang erforderlich für Oberteile und Kleider.', 'Bust measurement is required for tops and dresses.'));

  const errs = validateInput(table, isTop, parseFloat(bust), parseFloat(waist), parseFloat(hip), { pattern, oberbust, height, kids });
  if (errs.length) return showError(srT('Bitte prüfe deine Eingabe:', 'Please check your input:') + `<br>${errs.join('<br>')}<br>` + srT('Bei Fragen kontaktiere uns gern.', 'If you have any questions, please contact us.'));

  const inputs = { bust, oberbust, waist, hip, height, arm, upperArm, thigh, calf };
  const res = computeResult(Object.assign({ category, pattern, table }, inputs));
  const out = document.getElementById('result');
  if (out) {
    srInjectCss();
    out.innerHTML = generateReport(res, { name: srPatternName(), inputs });
    out.style.display = 'block';
    if (out.scrollIntoView) out.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

const NO_PATTERN_MSG = 'Bitte wähle zuerst deinen Schnitt aus. Der Größenrechner rechnet immer mit der Maßtabelle deines Schnitts.';
const srNoPatternMsg = () => srT(NO_PATTERN_MSG, 'Please choose your pattern first. The size calculator always uses the size chart of your pattern.');
// Schnittname ohne Satzzeichen am Ende (der englische Produkttitel endet im Theme mit einem Komma)
function srPatternName() {
  const n = (typeof window !== 'undefined' && window.SEAMONE_PRODUCT_NAME) || '';
  return String(n).replace(/[\s,;:–-]+$/, '');
}
// Schnitt gewählt = Maßtabelle vorhanden (Produktseite oder Auswahl auf der Größenrechner-Seite)
function hasPatternSelected() {
  if (tableFromProductData(readProductData())) return true;
  return typeof window !== 'undefined' && Array.isArray(window.SEAMONE_PRODUCT_TABLE) && window.SEAMONE_PRODUCT_TABLE.length > 0;
}

function showError(message) {
  const out = document.getElementById('result');
  if (out) { out.innerHTML = `<div class="error-message">${message}</div>`; out.style.display = 'block'; }
}

// ===== MODAL / KATEGORIE (unverändert übernommen, Kinder entfernt) =====
function openSizeCalculator() {
  const m = document.getElementById('sizeCalculatorModal');
  if (m) { m.style.display = 'block'; document.body.style.overflow = 'hidden'; initializeCalculator(); }
}
function closeSizeCalculator() {
  const m = document.getElementById('sizeCalculatorModal');
  if (m) { m.style.display = 'none'; document.body.style.overflow = 'auto'; resetCalculator(); }
}
function resetCalculator() {
  ['bust','oberbust','waist','hip','height','arm','upperArm','thigh','calf'].forEach(f => { const el = document.getElementById(f); if (el) el.value = ''; });
  const out = document.getElementById('result'); if (out) { out.innerHTML = ''; out.style.display = 'none'; }
  currentCategory = 'women'; updateCategoryTabs(); updateBustFieldVisibility();
}
function initializeCalculator() {
  updateCategoryTabs();
  const p = document.getElementById('pattern');
  if (p && !p._seamoneBound) { p.addEventListener('change', updateBustFieldVisibility); p._seamoneBound = true; }
  applyProductContext();
}
function applyProductContext() {
  // Ausgewählten Schnitt im Kopf anzeigen (nur Produktseite)
  const name = srPatternName();
  const sub = document.querySelector('#sizeCalculatorModal .calculator-header p');
  if (sub) {
    if (name) sub.innerHTML = srT('Ausgewählt: ', 'Selected: ') + '<strong>' + name + '</strong>';
    else sub.textContent = srT('Finde deine perfekte Schnittmuster-Größe', 'Find your perfect pattern size');
  }

  // Ohne Schnitt: Eingabe ausblenden, Hinweis zeigen
  const form = document.getElementById('sizeCalculatorForm');
  if (!hasPatternSelected()) {
    if (form) form.style.display = 'none';
    showError(srNoPatternMsg());
    return;
  }
  if (form) form.style.display = '';

  // Kategorie (Damen/Herren) auf der Produktseite automatisch setzen
  const cat = (typeof window !== 'undefined') ? window.SEAMONE_PRODUCT_CATEGORY : null;
  const tabs = document.querySelector('.category-tabs');
  if (cat) {
    currentCategory = cat;
    updateCategoryTabs();
    if (tabs) tabs.style.display = 'none';   // Produktseite: Kategorie ist bekannt
  } else if (tabs) {
    tabs.style.display = 'flex';             // QR-Seite: Tabs sichtbar
  }

  // Schnittmuster-Typ auf der Produktseite automatisch setzen
  const sel = document.getElementById('pattern');
  if (!sel) return;
  const group = sel.closest('.input-group');
  const kind = srPatternKind((typeof window !== 'undefined') ? window.SEAMONE_PRODUCT_PATTERN : null, name);
  [...sel.options].forEach(o => { o.hidden = !!(kind.choice && !kind.choice.includes(o.value)); });
  const lab = group && group.querySelector('label');
  if (lab) {
    if (lab.dataset.srOrig == null) lab.dataset.srOrig = lab.textContent;
    lab.textContent = kind.choice ? srT('Was nähst du?', 'What are you sewing?') : lab.dataset.srOrig;
  }
  if (kind.pat && !kind.choice) {
    sel.value = kind.pat;                     // Produktseite: Typ ist bekannt
    if (group) group.style.display = 'none';  // Schnittmuster-Auswahl ausblenden
  } else if (kind.choice) {
    if (!kind.choice.includes(sel.value) || sel.dataset.srFor !== name) sel.value = kind.pat; // neuer Schnitt: Voreinstellung
    sel.dataset.srFor = name;
    if (group) group.style.display = 'block'; // Schnitt für Oberteil und Kleid: Kundin wählt, was sie näht
  } else if (group) {
    group.style.display = 'block';            // QR-Seite: Auswahl sichtbar lassen
  }
  updateBustFieldVisibility();
}

// Art des Schnitts (Simo, 22.10.2026): Das Theme setzt sie nach der Produktart („Damen“) und erkennt so weder
// Kleider noch Röcke. Deshalb zusätzlich am Schnittnamen: „…kleid“ = Kleid, „…rock“ = Rock.
// Schnitt für beides (z. B. „Tunika, Bluse & Kleid“, „Hoodiekleid & Hoodie“): Kundin wählt Oberteil oder Kleid.
function srPatternKind(pat, name) {
  const n = String(name || '').toLowerCase()
    .replace(/pdf\s*(&|und|and)\s*pap\w*/g, '').replace(/schnittmuster|sewing pattern/g, '').replace(/[\s,;:–-]+$/, '');
  if (pat === 'top' && /kleid|dress/.test(n)) {
    return /&|,|\bund\b|\band\b|\boder\b|\bor\b/.test(n) ? { pat: 'top', choice: ['top', 'dress'] } : { pat: 'dress', choice: null };
  }
  if (pat === 'pants' && /rock|skirt/.test(n) && !/hose|trouser|pants/.test(n)) return { pat: 'skirt', choice: null };
  return { pat: pat || null, choice: null };
}
function setCategory(category) {
  currentCategory = category; updateCategoryTabs();
  const out = document.getElementById('result'); if (out) out.style.display = 'none';
}
function updateCategoryTabs() {
  document.querySelectorAll('.category-tab').forEach(tab => {
    tab.classList.remove('active');
    const want = currentCategory === 'women' ? 'damen' : 'herren';
    if (tab.textContent.toLowerCase().includes(want)) tab.classList.add('active');
  });
}
function updateBustFieldVisibility() {
  const pattern = document.getElementById('pattern')?.value;
  const bustGroup = document.getElementById('bustGroup');
  const oberbustGroup = document.getElementById('oberbustGroup');
  const bustField = document.getElementById('bust');
  const isBottom = (pattern === 'pants' || pattern === 'skirt');
  if (bustGroup && bustField) {
    if (isBottom) { bustGroup.style.display = 'none'; bustField.removeAttribute('required'); }
    else { bustGroup.style.display = 'block'; bustField.setAttribute('required', 'required'); }
  }
  // Kinderschnitt: keine Brustanpassung, keine Zusatzmaße (die Kindertabelle hat sie nicht)
  const kids = hasPatternSelected() && srIsKidsTable(getActiveTable(), srPatternName());
  if (oberbustGroup) oberbustGroup.style.display = (isBottom || kids) ? 'none' : 'block';
  // optionale Zusatzmaße: Arm bei Oberteilen, Bein bei Hosen
  const show = (id, on) => { const g = document.getElementById(id); if (g) g.style.display = on ? 'block' : 'none'; };
  show('armGroup', !isBottom && !kids); show('upperArmGroup', !isBottom && !kids);
  show('thighGroup', pattern === 'pants' && !kids); show('calfGroup', pattern === 'pants' && !kids);
  // englische Shopseite: Beschriftung der Zusatzfelder (stehen im Theme nur auf Deutsch)
  if (srIsEnglish()) {
    const lab = (id, text) => { const l = document.querySelector('label[for="' + id + '"]'); if (l) l.textContent = text; };
    lab('arm', 'Arm length (cm) – optional, from the shoulder point over the bent elbow to the wrist:');
    lab('upperArm', 'Upper arm (cm) – optional, at the fullest point:');
    lab('thigh', 'Thigh (cm) – optional, at the fullest point:');
    lab('calf', 'Calf (cm) – optional, at the fullest point:');
  }
}

// Deutsche Produktseite (Simo, 02.11.2026): UK/US unter jeder Größe der Maßtabelle, wie es das Theme auf Englisch zeigt.
// Werte aus der interaktiven Tabelle (uk_sizes/us_sizes), Spalte über data-size-index. Kinder: Altersangabe steht schon im Kopf.
function srSizeHeaderUkUs() {
  if (typeof document === 'undefined' || srIsEnglish()) return;
  const P = readProductData();
  if (!P || !Array.isArray(P.uk_sizes) || !Array.isArray(P.us_sizes)) return;
  if (srIsKidsTable(tableFromProductData(P), srPatternName() + ' ' + document.title)) return;
  document.querySelectorAll('th.size-header').forEach(th => {
    if (th.querySelector('.smn-ukus')) return;
    const i = parseInt(th.dataset.sizeIndex, 10);
    if (isNaN(i) || P.uk_sizes[i] == null || P.us_sizes[i] == null) return;
    const n = document.createElement('small');
    n.className = 'smn-ukus';
    n.style.cssText = 'display:block;font-size:.85em;opacity:.7;font-weight:400;white-space:nowrap';
    n.textContent = String(P.uk_sizes[i]).trim() + ' · ' + String(P.us_sizes[i]).trim();
    const eu = th.querySelector('small');
    if (eu) eu.after(n); else th.appendChild(n);
  });
}

if (typeof window !== 'undefined') {
  window.onclick = function (e) { const m = document.getElementById('sizeCalculatorModal'); if (e.target == m) closeSizeCalculator(); };
  document.addEventListener('DOMContentLoaded', function () {
    console.log('Size Calculator bereit');
    srSizeHeaderUkUs(); [800, 2500].forEach(ms => setTimeout(srSizeHeaderUkUs, ms)); // Tabelle wird teils später gezeichnet
  });
}

// Für Tests unter Node
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { computeResult, computeCup, generateOutput, generateReport, validateInput, tableFromProductData, srPatternKind, srIsKidsTable, computeKidsResult, WOMEN_NEW, WOMEN_OLD, MEN_SIZES,
    setSystem: (s) => currentSystem = s, setCategory: (c) => currentCategory = c };
}